module.exports = __webpack_public_path__ + "img/915.9e95f799.png";